import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import { ChallengeScheme, ErrorScheme, Feed } from "client-v2";
import { useEffect, useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import { Player } from "@lottiefiles/react-lottie-player";
import ChallengeLoadingAnimation from "../../assets/animations/challenge_loading.json";
import { State } from "../../redux";
import { useSelector } from "react-redux";
import ChallengeCell from "../cell/ChallengeCell";

const screenSize1: any = "1350px";
const screenSize2: any = "1024px";
const Container = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${ColorV2.surface.background};
	padding: 80px 150px;
	${media.lessThan(screenSize1)`
        padding: 80px 65px;
    `}
	${media.lessThan(screenSize2)`
        padding: 80px 48px;
    `}
    ${media.lessThan("medium")`
        padding: 36px 32px 110px;
    `}
    ${media.lessThan("small")`
        padding: 36px 24px 110px;
    `}
`;
const DataView = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;
	overflow: scroll;
	width: -webkit-fill-available;
	width: -moz-available;
	padding: 0px 150px;
	margin: 48px -150px 0px;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
	${media.lessThan(screenSize1)`
        padding: 0px 65px;
         margin: 48px -65px 0px;
    `}
	${media.lessThan(screenSize2)`
        padding: 0px 48px;
        margin: 48px -48px 0px;
    `}
    ${media.lessThan("medium")`
        padding: 0px 32px;
        margin: 32px -32px 0px;
		flex-direction: column;
    `}
    ${media.lessThan("small")`
        padding: 0px 24px;
        margin: 32px -24px 0px;
		flex-direction: column;
    `}
`;

const CrossSell = (props: Props) => {
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);

	const [loading, setLoading] = useState(false);
	const [challenges, setChallenges] = useState<ChallengeScheme[]>([]);

	useEffect(() => {
		getChallenges();
	}, []);

	const getChallenges = async () => {
		setLoading(true);
		Feed.getForLetter({
			version: 1,
		})
			.then((result) => {
				const tempChallenge: ChallengeScheme[] = [];
				result.data.map((i) =>
					i.rendedData.map((j) => tempChallenge.push(j.challenge))
				);
				setChallenges(tempChallenge);
				setLoading(false);
			})
			.catch((e: ErrorScheme) => {
				setLoading(false);
			});
	};

	return (
		<Container>
			<Text type="h4" weight="semibold">
				Otras iniciativas que te pueden interesar
			</Text>
			<DataView>
				{loading || challenges.length <= 0 ? (
					<Player
						style={{
							width: isMobile ? "100%" : 388,
							height: 315,
						}}
						loop={true}
						autoplay={true}
						src={ChallengeLoadingAnimation}
					/>
				) : (
					challenges.map((challenge) => (
						<ChallengeCell
							challenge={challenge}
							amount={challenge.amount}
						/>
					))
				)}
			</DataView>
		</Container>
	);
};
export default CrossSell;
export interface Props {}
